import { FoerderprogrammDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/foerderprogramm-display-model';
import { FoerderprogrammService } from '@/api/service-index';
import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FoerderprogrammResolver  {

  constructor(protected foerderprogrammService: FoerderprogrammService) {
    //
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<FoerderprogrammDisplayModel[] | null> {
    return this.foerderprogrammService.apiFoerderprogrammGet().pipe(
      map(response => {
        if (response.foerderprogramme)
          return response.foerderprogramme;

        return null;
      }),
      catchError(er => {
        console.log('error', er);
        return of(er);
      })
      );
  }
}
